"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recoilPersist = void 0;
const recoil_1 = require("recoil");
/**
 * Recoil module to persist state to storage
 *
 * @param config Optional configuration object
 * @param config.key Used as key in local storage, defaults to `recoil-persist`
 * @param config.storage Local storage to use, defaults to `localStorage`
 */
const recoilPersist = (config = {}) => {
    if (typeof window === 'undefined') {
        return {
            persistAtom: () => { },
        };
    }
    const { key = 'recoil-persist', storage = localStorage } = config;
    const persistAtom = ({ onSet, node, trigger, setSelf }) => {
        if (trigger === 'get') {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => {
                    if (s.hasOwnProperty(node.key)) {
                        setSelf(s[node.key]);
                    }
                });
            }
            if (state.hasOwnProperty(node.key)) {
                setSelf(state[node.key]);
            }
        }
        onSet(async (newValue) => {
            const state = await getState();
            if (newValue !== null &&
                newValue !== undefined &&
                newValue instanceof recoil_1.DefaultValue &&
                state.hasOwnProperty(node.key)) {
                delete state[node.key];
            }
            else {
                state[node.key] = newValue;
            }
            setState(state);
        });
    };
    const getState = () => {
        const toParse = storage.getItem(key);
        if (toParse === null || toParse === undefined) {
            return {};
        }
        if (typeof toParse === 'string') {
            return parseState(toParse);
        }
        if (typeof toParse.then === 'function') {
            return toParse.then(parseState);
        }
        return {};
    };
    const parseState = (state) => {
        if (state === undefined) {
            return {};
        }
        try {
            return JSON.parse(state);
        }
        catch (e) {
            console.error(e);
            return {};
        }
    };
    const setState = (state) => {
        try {
            //TODO for React Native `AsyncStorage`, we should be using `mergeItem`
            // to merge existing stringified object with new one
            storage.setItem(key, JSON.stringify(state));
        }
        catch (e) {
            console.error(e);
        }
    };
    return { persistAtom };
};
exports.recoilPersist = recoilPersist;
